// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OZYK","type":"styles_type__2yj3J","choices":"styles_choices__3SeBb"};